import React from 'react';

import { Paper } from '@mui/material';

export default function JsonBlock({ value }: { value: unknown }) {
  return (
    <Paper variant="outlined" component="pre" sx={{ m: 0, p: 2, overflow: 'auto', maxHeight: 280, fontSize: 12 }}>
      {JSON.stringify(value, null, 2)}
    </Paper>
  );
}
